import styled from 'styled-components';

import AppPreviewLeft from '~/images/app-preview-1.png';
import AppPreviewRight from '~/images/app-preview-2.png';

export const SignUpContainer = styled.div`
  width: 100%;
  min-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;

  > div {
    width: 100%;
    margin: auto;
  }
`;

export const AppPreviewImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`;

export const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
`;

export const AppPreviewImageLeft = styled.img.attrs({
  src: AppPreviewLeft,
})`
  position: absolute;
  top: 0;
  left: 0;
`;

export const AppPreviewImageRight = styled(AppPreviewImageLeft).attrs({
  src: AppPreviewRight,
})`
  left: auto;
  right: 0;
`;

export const SidebarLine = styled.div<{ position: 'left' | 'right' }>`
  position: absolute;
  width: 1px;
  height: 100vh;
  top: 48px;
  background-color: ${({ theme }) => theme.colors.border.semi};
  left: ${({ position }) => (position === 'left' ? '240px' : 'auto')};
  right: ${({ position }) => (position === 'right' ? '299px' : 'auto')};
`;

export const FakeCollapseButton = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.normal};
  color: rgb(102, 102, 102);
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 18px;
  left: 35px;

  svg {
    transform: rotate(-90deg);
  }
`;

export const FakeSidebarContainer = styled.div`
  position: fixed;
  width: 300px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;
